import WaiverPreview from "./WaiverPreview";
import { useWaiverState } from "./WaiverProvider";

export default function WaiverPreviewWrapper() {
  const { item, isDirty } = useWaiverState();

  if (!item) {
    return null;
  }

  return <WaiverPreview item={item} isDirty={isDirty} />;
}
